import { useEffect, useRef } from 'react';
import { useLettersCountStore, useLoginStore } from '@lib/store';

const REFRESH_COUNT = 30000;

export const useLettersCount = () => {
  const loginStore = useLoginStore();
  const letterContentStore = useLettersCountStore();

  const timer = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    const refresh = () => letterContentStore.getLettersCount();

    const startTimer = () => {
      stopTimer();
      refresh();
      timer.current = setInterval(refresh, REFRESH_COUNT);
    };

    const stopTimer = () => {
      if (!timer.current) return;
      clearInterval(timer.current);
      timer.current = null;
    };

    loginStore.data ? startTimer() : stopTimer();

    return () => {
      stopTimer();
    };
  }, [loginStore.data]);
};
